import React from "react";

const AppML_Case_TextFile = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case TextFile</h1>
      <p>This is the AppML Case TextFile page content.</p>
    </div>
  );
};

export default AppML_Case_TextFile;
